import React from 'react';
import classes from "./ErrorBoundary.module.css";
import Header from '../components/Header';
import { useNavigate, useRouteError } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
import SubLayout from '../components/SubLayout';

const ErrorBoundary = () => {
    const error = useRouteError();
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <>
            <Header hideLanguage={true} />
            <SubLayout>

            {/* <div className={classes.container}> */}

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/home");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("49")}</h2>
                </div>

                <div className={classes.message_box}>
                    <div className={classes.message_container}>
                        <p className={classes.text}>{error?.message || t("50")}</p>
                    </div>
                </div>

                <div className={classes.btn_container}>
                    <button type='button' className={classes.btn} onClick={() => navigate("/home")}>
                        {t("51")}
                    </button>
                </div>

            {/* </div> */}
            </SubLayout>


        </>
    )
}

export default ErrorBoundary